/** @jsxImportSource @emotion/react */

import {Input} from 'antd'
import useInputable from './useInputable.mjs'

const InputText = ({
    allowClear,
    changeDelay,
    parse,
    selectOnFocus,
    test,
    transform,
    value,
    onChange,
    onBlur,
    onInput,
    ...props
}) => {
    const {
        callbackRef,
        handleBlur,
        handleClick,
        handleCompositionEnd,
        handleCompositionStart,
        handleInput,
        inputValue,
    } = useInputable({
        allowClear,
        changeDelay,
        parse,
        selectOnFocus,
        test,
        transform,
        value,
        onChange,
        onBlur,
        onInput,
    })

    const style = {
        color: 'inherit',
        textAlign: 'inherit',
        ...props.style,
    }

    return (
        <div
            ref={callbackRef}
            style={{display: 'contents'}}
            onClick={handleClick}
        >
            <Input
                allowClear={allowClear}
                size="small"
                value={inputValue}
                onBlur={handleBlur}
                onCompositionEnd={handleCompositionEnd}
                onCompositionStart={handleCompositionStart}
                onInput={handleInput}
                {...props}
                style={style}
            />
        </div>
    )
}

export default InputText
